module.exports = __webpack_public_path__ + "static/media/annabelle-comes-home.217296c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/annabelle-comes-home.jpg
// module id = 291
// module chunks = 0